import { render } from "./RemoveTeamPage.vue?vue&type=template&id=c67ffe10&scoped=true"
import script from "./RemoveTeamPage.vue?vue&type=script&lang=js"
export * from "./RemoveTeamPage.vue?vue&type=script&lang=js"

import "./RemoveTeamPage.vue?vue&type=style&index=0&id=c67ffe10&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c67ffe10"]])

export default __exports__